import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-founders-day',
  templateUrl: './founders-day.component.html',
  styleUrls: ['./founders-day.component.scss']
})
export class FoundersDayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
